export default [
	{ name: 'gmail' },
	{ name: 'yahoo' },
	{ name: 'hotmail' },
	{ name: 'live' },
	{ name: 'aol' },
	{ name: 'outlook' }
];
